interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: (number | "ellipsis")[] = [];
  for (let i = 1; i <= totalPages; i += 1) {
    if (i === 1 || i === totalPages || Math.abs(i - page) <= 1) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== "ellipsis") {
      pages.push("ellipsis");
    }
  }

  return (
    <div className="flex items-center justify-center gap-1.5 mt-10">
      <button
        type="button"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        className="h-9 px-3 rounded-md border border-background-300/70 text-sm text-foreground-300 disabled:opacity-35 disabled:cursor-not-allowed hover:border-primary-400 hover:text-foreground-50 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>
      {pages.map((item, index) =>
        item === "ellipsis" ? (
          <span key={`e-${index}`} className="w-9 h-9 flex items-center justify-center text-foreground-600">
            …
          </span>
        ) : (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`w-9 h-9 rounded-md text-sm transition-colors cursor-pointer ${
              item === page
                ? "bg-primary-500 text-background-50 font-medium"
                : "border border-background-300/70 text-foreground-300 hover:border-primary-400 hover:text-foreground-50"
            }`}
          >
            {item}
          </button>
        ),
      )}
      <button
        type="button"
        disabled={page === totalPages}
        onClick={() => onChange(page + 1)}
        className="h-9 px-3 rounded-md border border-background-300/70 text-sm text-foreground-300 disabled:opacity-35 disabled:cursor-not-allowed hover:border-primary-400 hover:text-foreground-50 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}